import type { FunctionComponent, PropsWithChildren } from "react"

import { usePathname } from "next/navigation"

import { useTranslation } from "@/modules/i18n/components/useTranslation"
import { PaginationLink } from "@/modules/jobAds/client/components/PaginationLink/PaginationLink"
import { useJobAdsSearchParams } from "@/modules/jobAds/client/hooks/useJobAdsSearchParams"
import { MAX_JOB_ADS } from "@/modules/jobSearch/constants/response"
import { Pagination as SparkPagination } from "@/modules/layouts/components/Pagination/Pagination"

import styles from "./Pagination.module.css"

type PaginationProps = PropsWithChildren<{
  onPaginate?: () => void
  totalSize: number
}>

export const Pagination: FunctionComponent<PaginationProps> = ({ onPaginate, totalSize }) => {
  const { t } = useTranslation(["shared_action"])
  const pathname = usePathname()
  const searchParams = useJobAdsSearchParams()

  return (
    <SparkPagination
      ariaLabelNextButton={t("shared_action.pagination.next")}
      ariaLabelPageButton={t("shared_action.pagination.page")}
      ariaLabelPreviousButton={t("shared_action.pagination.previous")}
      className={styles.pagination}
      countPerPage={MAX_JOB_ADS}
      data-testid="job-ads-pagination"
      linkComponent={PaginationLink}
      onPaginate={onPaginate}
      pathname={pathname}
      scrollToTopOnPaginate={onPaginate ? undefined : "smooth"}
      searchParams={searchParams}
      siblingsCount={2}
      totalCount={totalSize}
    />
  )
}
